export const TERMS_AND_CONDITIONS_EVENTS = {
  VIEW_ONBOARDING_E_SIGNATURE: 'view_onboarding_e_signature',
  SELECT_ONBOARDING_E_SIGNATURE_BACK: 'select_onboarding_e_signature_back',
  SELECT_ONBOARDING_E_SIGNATURE_CONTINUE:
    'select_onboarding_e_signature_continue',
  VIEW_ONBOARDING_CONSUMER_ACCOUNT_CARDHOLDER_AGREEMENT:
    'view_onboarding_consumer_account_cardholder_agreement',
  SELECT_ONBOARDING_CONSUMER_ACCOUNT_CARDHOLDER_AGREEMENT_BACK:
    'select_onboarding_consumer_account_cardholder_agreement_back',
  SELECT_ONBOARDING_CONSUMER_ACCOUNT_CARDHOLDER_AGREEMENT_CONTINUE:
    'select_onboarding_consumer_account_cardholder_agreement_continue',
  SELECT_ONBOARDING_ACCOUNT_DISCLOSURE_PACKET_BACK:
    'select_onboarding_account_disclosure_packet_back',
  SELECT_ONBOARDING_ACCOUNT_DISCLOSURE_PACKET_CONTINUE:
    'select_onboarding_account_disclosure_packet_continue',
  VIEW_ONBOARDING_TERMS_AND_CONDITIONS: 'view_onboarding_terms_and_conditions',
  SELECT_ONBOARDING_TERMS_AND_CONDITIONS_BACK:
    'select_onboarding_terms_and_conditions_back',
  SELECT_ONBOARDING_TERMS_AND_CONDITIONS_CONTINUE:
    'select_onboarding_terms_and_conditions_continue',
  VIEW_ONBOARDING_PRIVACY_POLICY: 'view_onboarding_privacy_policy',
  SELECT_ONBOARDING_PRIVACY_POLICY_BACK:
    'select_onboarding_privacy_policy_back',
  SELECT_ONBOARDING_PRIVACY_POLICY_CONTINUE:
    'select_onboarding_privacy_policy_continue',
  SELECT_ONBOARDING_PATRIOT_ACT_CONTINUE:
    'select_onboarding_patriot_act_continue',
  SELECT_ONBOARDING_ECA_BACK: 'select_onboarding_eca_back',
  SELECT_ONBOARDING_ECA_CONTINUE: 'select_onboarding_eca_continue',
};
